import { apiSlice } from "../../apiSlice"; // Ensure this path is correct

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: '/Auth/Token',
        method: 'POST',
        body: { ...credentials },
      }),
      keepUnusedDataFor: 60,
    }),
    refreshToken: builder.mutation({
      query: (tokens) => ({
        url: '/Auth/Refresh',
        method: 'POST',
        body: { ...tokens },
      }),
      keepUnusedDataFor: 60,
    }),
  }),
});

export const {
  useLoginMutation,
  useRefreshTokenMutation,
} = authApiSlice;

export const { endpoints } = authApiSlice;